import {Button, Form, Col} from "react-bootstrap";
import {Formik, getIn} from "formik";
import {useEffect, useState} from "react";
import * as Yup from "yup";
import ApiManager from "../../api"
import AlertDismissible from "../../components/AlertDismissible";
import FormSwitch from "../../components/form/FormSwitch";

export default function UserSettingsXmlFeedForm() {
    const [initialFieldValues, setInitialFieldValues] = useState({});
    const [isSaved, setIsSaved] = useState(false)

    const validationSchema = Yup.object().shape({
        xmlfeed: Yup.object().shape({
            userId: Yup.string().required('Поле обязательно для заполнения.'),
            apiKey: Yup.string().required('Поле обязательно для заполнения.')
        })
    });

    useEffect(() => {
        new ApiManager()
            .request('user-settings')
            .then((data) => {
                let settings = {};
                for (const groupKey of Object.keys(data.data.settings)) {

                    const [group, key] = groupKey.split('.');

                    if (['xmlfeed', 'xmlriver'].includes(group)) {
                        settings[group] = Object.assign({}, settings[group], {[key]: data.data.settings[groupKey]});

                    }
                }

                setInitialFieldValues(settings)
            })


    }, []);

    function onSubmit(values) {

        let settings = {};

        for (const group of Object.keys(values)) {
            for (const key of Object.keys(values[group])) {
                settings[`${group}.${key}`] = values[group][key]
            }
        }

        new ApiManager()
            .create('user-settings', {settings})
            .then(() => {
                setIsSaved(true)
                setTimeout(() => setIsSaved(false), 15000)
            })
    }

    return (
        <>
            <AlertDismissible
                show={isSaved}
                onClose={() => setIsSaved(false)}
                variant="success">
                Настройки сохранены
            </AlertDismissible>
            <Formik
                enableReinitialize={true}
                initialValues={initialFieldValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({errors, handleChange, values, handleSubmit}) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Text muted><p className="fs-5">Доступы XmlStock</p></Form.Text>
                        <Form.Group as={Col} md="2" className="mb-3" controlId="xmlfeedUserId">
                            <Form.Label>Id пользователя</Form.Label>
                            <Form.Control
                                type="text"
                                name="xmlfeed.userId"
                                value={getIn(values, "xmlfeed.userId")}
                                onChange={handleChange}
                                isInvalid={!!getIn(errors, "xmlfeed.userId")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {getIn(errors, "xmlfeed.userId")}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="2" className="mb-3" controlId="xmlfeedApiKey">
                            <Form.Label>Ключ api</Form.Label>
                            <Form.Control
                                type="text"
                                name="xmlfeed.apiKey"
                                value={getIn(values, "xmlfeed.apiKey")}
                                onChange={handleChange}
                                isInvalid={!!getIn(errors, "xmlfeed.apiKey")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {getIn(errors, "xmlfeed.apiKey")}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="xmlfeedIsActive">
                            <FormSwitch label="Включить" name="xmlfeed.isActive"/>
                        </Form.Group>

                        <Form.Text muted><p className="fs-5">Доступы XmlRiver</p></Form.Text>
                        <Form.Group as={Col} md="2" className="mb-3" controlId="xmlriverUserId">
                            <Form.Label>Id пользователя</Form.Label>
                            <Form.Control
                                type="text"
                                name="xmlriver.userId"
                                value={getIn(values, "xmlriver.userId")}
                                onChange={handleChange}
                                isInvalid={!!getIn(errors, "xmlriver.userId")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {getIn(errors, "xmlfeed.userId")}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="2" className="mb-3" controlId="xmlriverApiKey">
                            <Form.Label>Ключ api</Form.Label>
                            <Form.Control
                                type="text"
                                name="xmlriver.apiKey"
                                value={getIn(values, "xmlriver.apiKey")}
                                onChange={handleChange}
                                isInvalid={!!getIn(errors, "xmlriver.apiKey")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {getIn(errors, "xmlriver.apiKey")}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="xmlriverIsActive">
                            <FormSwitch label="Включить" name="xmlriver.isActive"/>
                        </Form.Group>

                        <Button type="submit" variant="primary">Сохранить</Button>
                    </Form>
                )}
            </Formik>
        </>
    )
}
